import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { HeartSize } from './constants';
import { LoveMeterContext } from '../LoveContext';
import { isHate } from '../redux/scales';
import BrokenHeart from './BrokenHeart';
import BubblyHeart from './BubblyHeart';
import s from './LoveHeart.scss';
export var LoveHeart = function (_a) {
    var _b = _a.size, size = _b === void 0 ? HeartSize.Normal : _b, _c = _a.overlayType, overlayType = _c === void 0 ? 'cover' : _c, _d = _a.showFooter, showFooter = _d === void 0 ? true : _d, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement(LoveMeterContext.Consumer, null, function (_a) {
        var hasLoveChanged = _a.hasLoveChanged, lovePercentage = _a.lovePercentage;
        return hasLoveChanged ? (React.createElement("div", { className: classnames(s['overlay'], s["size-" + size], s["overlay-" + overlayType], className) }, typeof lovePercentage !== 'undefined' && (React.createElement("div", { className: s['floater'] },
            React.createElement("div", { className: s['heart-container'] },
                React.createElement("div", { className: s['heart'] }, isHate(lovePercentage) ? (React.createElement(BrokenHeart, { lovePercentage: lovePercentage, size: size })) : (React.createElement(BubblyHeart, { lovePercentage: lovePercentage, size: size })))),
            showFooter && (React.createElement("div", { className: s['footer'] }, isHate(lovePercentage)
                ? t('loveMeter.lessLikeThis')
                : t('loveMeter.moreLikeThis'))))))) : null;
    }));
};
LoveHeart.displayName = 'LoveHeart';
export default LoveHeart;
//# sourceMappingURL=LoveHeart.js.map